import React, { createContext, useContext, ReactNode } from 'react';

interface PersonalizationValues {
  layout?: {
    background?: string;
    backgroundType?: 'color' | 'gradient' | 'image';
  };
  card?: {
    background?: string;
    border?: string;
    borderRadius?: string;
    shadow?: string;
  };
  input?: {
    background?: string;
    border?: string;
    focusBorder?: string;
    focusRing?: string;
    text?: string;
    placeholder?: string;
    borderRadius?: string;
  };
  button?: {
    primary?: string;
    primaryText?: string;
    primaryHover?: string;
    disabledBackground?: string;
    disabledText?: string;
    borderRadius?: string;
  };
  text?: {
    primary?: string;
    secondary?: string;
    heading?: string;
  };
  badge?: {
    background?: string;
    text?: string;
    borderRadius?: string;
  };
  icon?: {
    primary?: string;
    secondary?: string;
  };
  informativeAnnouncement?: string;
  description?: string;
}

interface PersonalizationContextType {
  temporaryPersonalization: PersonalizationValues | null;
  setTemporaryPersonalization: (values: PersonalizationValues | null) => void;
}

export const PersonalizationContext = createContext<PersonalizationContextType | undefined>(undefined);

interface PersonalizationProviderProps {
  children: ReactNode;
}

export const PersonalizationProvider: React.FC<PersonalizationProviderProps> = ({ children }) => {
  const [temporaryPersonalization, setTemporaryPersonalization] = React.useState<PersonalizationValues | null>(null);

  return (
    <PersonalizationContext.Provider
      value={{
        temporaryPersonalization,
        setTemporaryPersonalization,
      }}
    >
      {children}
    </PersonalizationContext.Provider>
  );
};

export const usePersonalizationContext = (): PersonalizationContextType => {
  const context = useContext(PersonalizationContext);
  if (context === undefined) {
    throw new Error('usePersonalizationContext must be used within a PersonalizationProvider');
  }
  return context;
};

